import { QRCodeSVG } from 'qrcode.react'
import { Button, Modal } from '../ui'
import { useState } from 'react'
import { Download, Share2, QrCode } from 'lucide-react'

export const QRCodeGenerator = ({ url, title, description, size = 200 }) => {
    const [showModal, setShowModal] = useState(false)

    const downloadQR = () => {
        const svg = document.getElementById('qr-code-svg')
        const svgData = new XMLSerializer().serializeToString(svg)
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const img = new Image()

        canvas.width = size * 2
        canvas.height = size * 2

        img.onload = () => {
            ctx.fillStyle = 'white'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(img, 0, 0, size * 2, size * 2)

            const pngFile = canvas.toDataURL('image/png')
            const downloadLink = document.createElement('a')
            downloadLink.download = `${title.replace(/\s/g, '_')}_QR.png`
            downloadLink.href = pngFile
            downloadLink.click()
        }

        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)))
    }

    const shareQR = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: title,
                    text: description,
                    url: url
                })
            } catch (err) {
                console.log('Share failed:', err)
            }
        } else {
            // Fallback: Copy to clipboard
            navigator.clipboard.writeText(url)
            alert('Link gekopieerd naar klembord!')
        }
    }

    return (
        <>
            <Button
                onClick={() => setShowModal(true)}
                variant="secondary"
                icon={<QrCode size={18} />}
                className="gap-2"
            >
                QR Code
            </Button>

            <Modal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                title="📲 QR Code Delen"
            >
                <div className="flex flex-col items-center gap-6">
                    <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-gray-100">
                        <QRCodeSVG
                            id="qr-code-svg"
                            value={url}
                            size={size}
                            level="H"
                            includeMargin={true}
                        />
                    </div>

                    <div className="text-center">
                        <h3 className="font-bold text-lg text-gray-900 mb-2">{title}</h3>
                        <p className="text-sm text-gray-600 mb-4">{description}</p>
                        <code className="text-xs bg-gray-100 px-3 py-1 rounded-lg text-gray-700 font-mono break-all">
                            {url}
                        </code>
                    </div>

                    <div className="flex gap-3 w-full">
                        <Button
                            onClick={downloadQR}
                            variant="outline"
                            icon={<Download size={16} />}
                            className="flex-1"
                        >
                            Download
                        </Button>
                        <Button
                            onClick={shareQR}
                            variant="primary"
                            icon={<Share2 size={16} />}
                            className="flex-1"
                        >
                            Delen
                        </Button>
                    </div>

                    <p className="text-xs text-gray-400 text-center">
                        💡 Tip: Print deze QR code en hang hem op bij de ingang of bij jullie velden!
                    </p>
                </div>
            </Modal>
        </>
    )
}
